







































































import Vue from "vue";
import ChangelogComp from "@/components/menu/ChangelogComp.vue";
import LegalNoticeComp from "@/components/legal/LegalNoticeComp.vue";
import _users from "../../services/endpoints/users";
import _cookies from "../../services/util/cookies";

export default Vue.extend({
	name: "MenuToolbarComp",
	props: {
		loggedIn: Boolean
	},
	components: {
		ChangelogComp,
		LegalNoticeComp,
	},
	data: () => ({
		showBuildCheck: false,
		legalNoticeOpen: false,
	}),
	computed: {
		buildCheckSuccess: function(): boolean {
			return this.$vStore.getters.buildCheck;
		},
		buildCheckIcon: function(): string {
			return this.buildCheckSuccess ? "verified_user" : "update";
		},
		showWarning: function(): boolean {
			return this.showBuildCheck || !this.buildCheckSuccess;
		},
		frontendBuild: function(): string {
			return this.$vStore.getters.frontendBuild;
		},
		backendBuild: function(): any {
			return this.$vStore.getters.backendBuild;
		},
	},
	methods: {
		logout: async function(): Promise<void> {
			await _users.invalidateSession();
			_cookies.deleteCookie("session");
			window.location.reload();
		},
		refreshPage: function(): void {
			window.location.reload();
		}
	},
});
